import styled, { css } from 'styled-components/macro';
import { MODE_TYPES } from '../../../../constants';
import { FlexJustifyBetween } from '../../../../shared-styles/flex';

export const Header = styled.div`
  font-size: ${({ theme }) => theme.typography.sizes.small};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  color: ${({ theme }) => theme.palette.black[50]};
`;

export const CardContainer = styled.div`
  max-width: 100%;
  background-color: ${(props) => props.theme.palette.white};
  border: 0.5px solid ${(props) => props.theme.palette.gray[50]};  
  border-radius: 10px;

  box-shadow:${({ theme }) => theme.palette.gray[50]} 0px 2px 6px;
  `;

export const Status = styled.span`
  font-size: ${({ theme }) => theme.typography.sizes.medium};
  font-weight: ${({ theme }) => theme.typography.weight.semiBold};
  color: ${({ theme }) => theme.palette.black[100]};
  margin-right: ${(props) => props.theme.spacing(5)};
`;

export const IconContainer = styled.div`
  height: 100%;
  width: 40px;
  grid-row: 1 / span 2;
`;

export const VerticalAlign = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const HeaderContainer = styled.div`
  ${FlexJustifyBetween}
`;

export const StatusContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 2px 1fr 20px;
  ${(props) => props.mode === MODE_TYPES.truckload
    && css`
      grid-template-columns: 1fr 20px;
    `}
`;

export const StatusContent = styled.div`
  display: grid;
  padding: ${(props) => props.theme.spacing(20)};
  grid-template-columns: 50px auto;
  grid-template-rows: auto auto;
`;

export const Divider = styled.div`
  border-left: 2px dashed ${(props) => props.theme.palette.lightGray[100]};
`;

export const InfoWrapper = styled.div`
  position: relative;
  top: 20px;
  right: 20px;
`;
